/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /*
   * Variant picker auto-correction.
   *
   * Some products do not offer every combination of options (e.g. the Arcus
   * bows: not every Series comes in every Finish). When the shopper's current
   * option combination matches no available variant, the picker is left
   * showing "$0.00" / "Item is unavailable" with a disabled add-to-cart
   * button, even though the newly chosen option IS purchasable in another
   * combination.
   *
   * This watches the dropdown variant pickers and, when a selection leaves
   * no matching available variant, automatically switches the conflicting
   * option(s) to the first valid values: it keeps the option the shopper
   * just changed, prefers to keep the other current selections (earlier
   * option positions first), and otherwise falls back to the first available
   * variant. The corrected values are chosen through the theme's own picker
   * controls, so price, availability and add-to-cart update normally.
   * Generic: works for any product using dropdown variant pickers.
   */

  var productJsonCache = {};
  var autoCorrecting = false;

  function getProductJson(handle) {
    if (!productJsonCache[handle]) {
      productJsonCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js').then(function(response) {
        if (!response.ok) throw new Error('Unable to load product data.');
        return response.json();
      }).catch(function(error) {
        delete productJsonCache[handle];
        throw error;
      });
    }
    return productJsonCache[handle];
  }

  function currentOptionValues(form) {
    var values = [];
    var inputs = form.querySelectorAll('input[data-single-option-selector]');
    for (var i = 0; i < inputs.length; i++) {
      var position = parseInt((inputs[i].getAttribute('data-index') || '').replace('option', ''), 10);
      if (position >= 1) values[position - 1] = inputs[i].value;
    }
    return values;
  }

  // Returns the variant to switch to, or null when the current selection
  // already matches an available variant (or cannot be corrected).
  function findFirstValidVariant(variants, values, changedPosition) {
    var optionCount = values.length;
    var available = variants.filter(function(variant) { return variant.available; });

    var exactMatch = available.some(function(variant) {
      for (var p = 0; p < optionCount; p++) {
        if (variant['option' + (p + 1)] !== values[p]) return false;
      }
      return true;
    });
    if (exactMatch) return null;

    var changedValue = values[changedPosition];
    var candidates = available.filter(function(variant) {
      return variant['option' + (changedPosition + 1)] === changedValue;
    });
    if (!candidates.length) return null;

    // Prefer candidates that keep the other current selections,
    // considering earlier option positions first.
    var remaining = candidates;
    for (var p = 0; p < optionCount; p++) {
      if (p === changedPosition) continue;
      var narrowed = remaining.filter(function(variant) {
        return variant['option' + (p + 1)] === values[p];
      });
      if (narrowed.length) remaining = narrowed;
    }

    var target = remaining[0];
    for (var q = 0; q < optionCount; q++) {
      if (target['option' + (q + 1)] !== values[q]) return target;
    }
    return null;
  }

  function selectPickerValue(form, position, value) {
    var input = form.querySelector('input[data-single-option-selector][data-index="option' + position + '"]');
    if (!input || input.value === value) return;
    var scope = input.closest('.select-popout') || input.closest('.selector-wrapper') || form;
    var option = scope.querySelector('[data-popout-option][data-value="' + CSS.escape(value) + '"]');
    if (option) {
      // Go through the theme's own picker control so labels, hidden inputs
      // and the theme's change handlers all update consistently.
      option.click();
    } else if ('value' in input) {
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  document.addEventListener('click', function(event) {
    var picked = event.target && event.target.closest ? event.target.closest('[data-popout-option]') : null;
    if (!picked || autoCorrecting) return;

    var form = picked.closest('form[data-product-form]');
    if (!form) return;

    var positionWrapper = picked.closest('[data-option-position]');
    var changedPosition = positionWrapper ? parseInt(positionWrapper.getAttribute('data-option-position'), 10) - 1 : 0;
    if (changedPosition < 0) changedPosition = 0;

    var handleMatch = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!handleMatch) return;
    var handle = handleMatch[1];

    // Run after the theme's own picker handler so we read the updated values.
    setTimeout(function() {
      if (autoCorrecting) return;
      getProductJson(handle).then(function(product) {
        if (!product || !product.variants) return;
        var values = currentOptionValues(form);
        if (!values.length || changedPosition >= values.length) return;
        var target = findFirstValidVariant(product.variants, values, changedPosition);
        if (!target) return;

        autoCorrecting = true;
        try {
          for (var p = 0; p < values.length; p++) {
            selectPickerValue(form, p + 1, target['option' + (p + 1)]);
          }
        } finally {
          setTimeout(function() { autoCorrecting = false; }, 0);
        }
      }).catch(function() { /* leave the picker untouched if product data cannot load */ });
    }, 0);
  });







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
